

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _squid = require('squid');

var _integration = require('js/lib/integration');

var _miniBrowser = require('js/lib/miniBrowser');

var _index = require('xo-models/src/auth/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$contingencyHandler', function () {
    function showGenericError(code) {
        return function () {
            var encoded = code ? window.btoa(code) : code;

            _uiRouter.$state.go('checkout.genericError', {
                code: encoded
            });
        };
    }

    function route(path) {
        return function () {
            _uiRouter.$state.go(path, { message: arguments[0] });
        };
    }

    function forbidden(err) {
        throw new _squid.$Forbidden(err);
    }

    function fallback(product) {
        return function (err) {
            throw new _squid.$FallbackError({
                reason: err,
                product: product
            });
        };
    }

    function addMissingTokens(urlQuery) {
        var payload = {
            'token': _angular.$rootScope.token || _squid.$meta.token
        };

        if (_squid.$meta.baToken) {
            payload.ba_token = _squid.$meta.baToken;
        }
        return _squid.$util.queryStringSplice(urlQuery, payload);
    }

    function handleStepupAuth(code, authModel, step_up_context) {
        authModel.stepupAuthRequired = true;

        var reasons = {
            VERIFY_USER_IDENTITY: 'step_up_auth_needed',
            PAYER_AUTHENTICATION_REQUIRED: 'login_required'
        };

        if (authModel.remembered) {
            _logger.$logger.debug('PLANNING_STEP_UP_REMEBERED_USER');
            authModel.logout().then(function () {
                _uiRouter.$state.go('checkout.login', {
                    targetPage: 'ONETOUCH_GENERIC_ERROR',
                    source: 'FRESH_START'
                });
            });
        } else if (step_up_context && !_angular2['default'].isObject(step_up_context)) {
            _logger.$logger.debug('PLANNING_STEP_UP_LOGIN_USER_TEST_TRAFFIC');
            var authChallengeNodeUrl = _squid.$config.urls.authChallengeNodeUrl;

            if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
                var hostname = _squid.$meta.stage ? _squid.$meta.stage : _angular.$location.host();

                authChallengeNodeUrl = authChallengeNodeUrl.replace('www.paypal.com', hostname);
            }

            authChallengeNodeUrl = _squid.$util.buildURL(authChallengeNodeUrl, {
                stepupContext: step_up_context,
                stsReturnUrl: _squid.$config.ulMeta.stsReturnUrl,
                returnUri: _squid.$config.ulMeta.authChallengeReturnUri + addMissingTokens(_angular.$window.location.search) + '&atoSuccess',
                locale: _squid.$locale.lang,
                flowId: 'xo',
                flowContext: 'funding'
            });

            if (authChallengeNodeUrl) {
                _squid.$util.redirect(authChallengeNodeUrl);
            }
        } else {
            _logger.$logger.debug('PLANNING_STEP_UP_LOGIN_USER_CONTROL_TRAFFIC');
            throw new _squid.$FallbackError({
                reason: reasons[code],
                product: 'ux'
            });
        }
    }

    return function (contingency) {
        // Leave a footprint here. The subsequent state where log how it goes..
        _logger.$logger.warn('contingency_handler', contingency);

        return contingency.handle({
            // Route
            ECONSENT_REQUIRED: route('checkout.econsent'),
            TRAVEL_RULE_ID_REQUIRED: route('checkout.travelRule'),
            INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: route('checkout.pageAddCardMeft.addCardFlow.addCard'),
            ELV_DECLINE: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_CREDIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_CONFIRMED_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
            NEED_AUTHENTICATED_CARD: route('checkout.updateCard.addCardFlow.addCard'),
            NEED_CREDIT_CARD_OR_BANK_ACCOUNT: route('checkout.pageAddFi.bank.add'),
            EXPIRED_CREDIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),
            NEGATIVE_BALANCE_RECOVERY: route('checkout.negativeBalanceRecovery'),
            PHONE_NUMBER_REQUIRED: route('checkout.addPhone'),
            SEPA_MANDATE_ACCEPTANCE_NEEDED: route('checkout.review'),
            TAX_ID_REQUIRED: route('checkout.addTaxId'),
            NEED_SHIPPING_ADDRESS: route('checkout.pageAddShipping.addShipping'),

            NEED_DEBIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
            EXPIRED_DEBIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),

            PAYER_AUTHENTICATION_REQUIRED: function PAYER_AUTHENTICATION_REQUIRED() {
                _uiRouter.$state.go('checkout.login', {
                    targetPage: 'PAYER_AUTHENTICATION_REQUIRED'
                });
            },

            // Generic Error Pages
            RESTRICTED_USER: showGenericError('RESTRICTED_USER'),
            PAYER_ACCOUNT_RESTRICTED: showGenericError('RESTRICTED_USER'),
            PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
            PAYMENT_ALREADY_DONE: showGenericError('PAYMENT_ALREADY_DONE'),
            DUPLICATE_INVOICE_ID: showGenericError('DUPLICATE_INVOICE_ID'),
            PAYMENT_DENIED: showGenericError('PAYMENT_DENIED'),
            PAYEE_ACCOUNT_RESTRICTED: showGenericError('PAYEE_ACCOUNT_LOCKED_OR_CLOSED'),
            INVALID_RESOURCE_ID: showGenericError('INVALID_RESOURCE_ID'),
            EXPIRED_SESSION: showGenericError('EXPIRED_SESSION'),
            PAYER_CANNOT_PAY: showGenericError('PAYER_CANNOT_PAY'),
            TRANSACTION_RECEIVING_LIMIT_EXCEEDED: showGenericError('PAYER_CANNOT_PAY'),
            PAYER_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_COUNTRY_NOT_ALLOWED'),
            PAYER_COUNTRY_NOT_ALLOWED_DCF: showGenericError('HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF'),
            PAYER_COUNTRY_NOT_ENABLED: showGenericError('PAYER_COUNTRY_NOT_ENABLED'),
            PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_LOGIN_COUNTRY_NOT_ALLOWED'),
            GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError('GAMING_FUNDING_SOURCE_VALIDATION_FAILED'),
            COMPLIANCE_VIOLATION: showGenericError('COMPLIANCE_VIOLATION'),
            DOMESTIC_TRANSACTION_REQUIRED: showGenericError('DOMESTIC_TRANSACTION_REQUIRED'),
            INTERNAL_SERVICE_ERROR: showGenericError('TRANSACTION_REFUSED'),
            NEGATIVE_BALANCE_TRANSACTION_REFUSED: showGenericError('NEGATIVE_BALANCE_TRANSACTION_REFUSED'),
            ACCOUNT_CANNOT_BE_FETCHED: showGenericError('ACCOUNT_CANNOT_BE_FETCHED'),
            BAD_RESPONSE: showGenericError('DEFAULT'),
            TRANSACTION_REFUSED_LEGACY_FALLBACK: showGenericError('TRANSACTION_REFUSED'),
            RISK_DENIED: showGenericError('TRANSACTION_REFUSED'),
            UNSUPPORTED_COUNTRY: showGenericError('UNSUPPORTED_COUNTRY'),
            AGREEMENT_ALREADY_CREATED: showGenericError('AGREEMENT_ALREADY_CREATED'),
            PAYMENT_NOT_APPROVED_FOR_EXECUTION: showGenericError('DEFAULT'),
            PAYER_ACCOUNT_LOCKED_OR_CLOSED: showGenericError('DEFAULT'),
            WALLET_PREFERENCE_SET_ERROR: showGenericError('DEFAULT'),
            ISSUANCE_PIN_SERVICE_ERROR: showGenericError('DEFAULT'),
            SENDING_LIMIT_EXCEEDED: showGenericError('SENDING_LIMIT_EXCEEDED'),
            PAYEE_ACCOUNT_LOCKED_OR_CLOSED: showGenericError('PAYEE_ACCOUNT_LOCKED_OR_CLOSED'),
            UNSUPPORTED_PAYEE_CURRENCY: showGenericError('UNSUPPORTED_PAYEE_CURRENCY'),
            PAYMENT_CANNOT_BE_INITIATED: showGenericError('DEFAULT'),
            PERMISSION_DENIED: showGenericError('DEFAULT'),
            INVALID_TOKEN: showGenericError('DEFAULT'),
            INVALID_FUNDING_OPTION: showGenericError('DEFAULT'),
            VALIDATION_ERROR: showGenericError('DEFAULT'),
            SHIPPING_ADDRESS_INVALID: showGenericError('DEFAULT'),
            INVALID_ARGUMENT: showGenericError('DEFAULT'),
            CREDIT_PAYMENT_NOT_ALLOWED: showGenericError('DEFAULT'),
            MALFORMED_REQUEST: showGenericError('DEFAULT'),
            TWOFA_INACTIVE: showGenericError('DEFAULT'),
            ERROR: showGenericError('DEFAULT'),
            ISSUER_DECLINE: showGenericError('DEFAULT'),
            UNSUPPORTED_CUP_SECURECARD: showGenericError('DEFAULT'),
            STUDENT_ACCOUNT: showGenericError('STUDENT_ACCOUNT'),
            UAL_ISSUANCE_UPDATE_SCOPE_ERROR: showGenericError('DEFAULT'),
            // Forbidden
            BUYER_NOT_SET: forbidden,

            // Other
            TRANSACTION_REFUSED: function TRANSACTION_REFUSED(message, data) {
                var clearedRT = data.clearedRT;

                if (clearedRT) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CONTINGENCY',
                        to: 'process_fallback',
                        routing_reason: 'TRANSACTION_REFUSED'
                    });
                }

                // always go to generic error page, even if logout fails
                _index.$AuthModel.instance().logout()['finally'](showGenericError('TRANSACTION_REFUSED'));
            },

            PAYER_INVALID_FOR_PAYMENT: function PAYER_INVALID_FOR_PAYMENT() {
                // Payer is not same payer checkout session was created for.
                return _index.$AuthModel.instance().logout()['finally'](function () {
                    return _uiRouter.$state.go('checkout.login', {}, {
                        reload: true
                    });
                });
            },

            CANNOT_PAY_SELF: function CANNOT_PAY_SELF() {
                _index.$AuthModel.instance().meta.selfPay = true;
                _angular.$rootScope.contingency = {};
                _angular.$rootScope.contingency.message = 'CANNOT_PAY_SELF';

                return _index.$AuthModel.instance().logout()['finally'](function () {
                    return _uiRouter.$state.go(_uiRouter.$state.current, {}, {
                        reload: true
                    });
                });
            },

            VERIFY_USER_IDENTITY: function VERIFY_USER_IDENTITY(message, data) {
                var clearedRT = data.clearedRT;

                if (clearedRT) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CONTINGENCY',
                        to: 'process_fallback',
                        routing_reason: 'VERIFY_USER_IDENTITY'
                    });
                }

                return handleStepupAuth('VERIFY_USER_IDENTITY', _index.$AuthModel.instance(), data.step_up_context);
            },

            LOGIN_CONTINGENCY: function LOGIN_CONTINGENCY() {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    return _miniBrowser.$miniBrowser.frameBust(_angular.$rootScope.token);
                }

                return fallback('ux');
            },

            DEFAULT: function logUnhandledContingency() {
                _logger.$logger.warn('ui_unhandled_contingency_' + this.message);
                throw new _squid.$FallbackError({
                    reason: 'unhandled_contingency',
                    product: 'ux'
                });
            }
        });
    };
});

_uiRouter.$state;

_logger.$logger;

_squid.$config;

_squid.$FallbackError;

_squid.$Forbidden;

_squid.$locale;

_squid.$meta;

_squid.$util;

_integration.$integration;

_miniBrowser.$miniBrowser;

_index.$AuthModel;


//////////////////
// WEBPACK FOOTER
// ./js/lib/contingency.js
// module id = ./js/lib/contingency.js
// module chunks = 0